import { classnames } from 'Utils/classnames/classnames.utils';

import { getCursorClass } from 'Components/utils/form/form.util';

export const themes = {
  default: (props) => {
    const { color, isChecked, isDisabled, isReadOnly, isRequired, validationState } = props;

    const hasValidStyle = validationState === 'IS_VALID' && !isDisabled && !isReadOnly;
    const hasInvalidStyle = validationState === 'IS_INVALID' && !isDisabled && !isReadOnly;

    return {
      thRoot: 'flex gap-10 items-center',
      thLabel: classnames(
        'mt-1 inline-block text-14 font-bold leading-tight text-black',
        getCursorClass({ hasPointer: true, ...props }),
      ),
      thChecked: classnames(
        'outline-custom-sibling flex h-24 w-24 shrink-0 items-center justify-center rounded-8 border p-2 text-14',
        {
          'border-black': !isDisabled,
          'border-grey bg-pearl text-grey': isDisabled,
          'border-success text-success': hasValidStyle && isRequired,
          'formik-errored border-red text-red': hasInvalidStyle && isRequired,
        },
      ),
      thSwitch: classnames(
        'flex h-32 w-56 items-center rounded-pill border-1 p-4 transition-all duration-250 ease-in',
        getCursorClass({ hasPointer: true, ...props }),
        {
          'border-lightGrey bg-lightGrey text-lightGrey': !isChecked || isDisabled,
          [`bg-${color} border-${color}`]: isChecked && !isDisabled,
        },
      ),
      thSwitchToggler: classnames(
        'block flex h-24 w-24 items-center justify-center rounded-full bg-white leading-0 text-lightGrey transition-all duration-250 ease-in',
        {
          'transform ltr:translate-x-full rtl:-translate-x-full': isChecked,
          [`text-${color}`]: isChecked && !isDisabled,
        },
      ),
    };
  },
};
